<template>
  <div>
    <v-container v-if="data">
      <!-- page header -->
      <v-row>
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="8"
          xl="6"
          offset-xl="3"
        >
          <v-card outlined>
            <v-card-title class="text-uppercase headline mb-4">{{
              data.packageCode
            }}</v-card-title>
            <v-card-subtitle>
              <p class="subtitle-1">{{ stripHtml(data.title) }}</p>
              <p class="subtitle-1">{{ stripHtml(data.subtitle) }}</p>
            </v-card-subtitle>
            <v-card-actions v-if="
                  (data.packageVideos &&
                    data.packageVideos.length > 0 &&
                    (data.packageVideos[0].downloadUrl ||
                      data.packageVideos[0].link)) ||
                  data.youtubeVideoUrl
                ">
              <v-btn color="red" dark depressed @click="onYoutube">
                Watch Package Video
                <v-icon right dark>mdi-youtube</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <!-- page header -->
      <!-- slider -->
      <v-row>
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="8"
          xl="6"
          offset-xl="3"
        >
          <v-carousel cycle height="300">
            <v-carousel-item v-for="(img, i) in data.images" :key="i">
              <v-img
                cover
                :src="img.downloadUrl"
                lazy-src="https://i.picsum.photos/id/25/10/6.jpg"
                style="height:100%;"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
      <!-- slider -->
      <!-- content -->
      <v-row>
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="8"
          xl="6"
          offset-xl="3"
        >
          <v-card outlined>
            <!-- title -->
            <v-card-title class="mb-4">{{
              stripHtml(data.title)
            }}</v-card-title>
            <!-- subtitle -->
            <v-card-subtitle class="mb-2">{{
              stripHtml(data.subtitle)
            }}</v-card-subtitle>
            <!-- blurbs -->
            <v-card-text v-for="(blurb, index) in data.blurbs" :key="index">
              <div class="blurbTitle mb-3">
                <i class="mdi ml-1 mr-1" :class="blurb.icon"></i>
                {{ stripHtml(blurb.title) }}
              </div>
              <span v-html="blurb.content"></span>
            </v-card-text>
            <!-- blurbs -->
            <!-- terms -->
            <v-card-subtitle class="subtitle-1 font-weight-bold"
              >Terms & Conditions</v-card-subtitle
            >
            <v-card-text v-html="terms.content"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- content -->
    </v-container>

    <!-- dialog -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="red--text mb-3">
          <v-icon class="mr-2" color="error">mdi-alert-outline</v-icon>Oops,
          package not found
        </v-card-title>
        <v-card-text>
          <p>
            Package
            <span class="text-uppercase font-weight-bold">{{
              this.$route.params.packagecode
            }}</span>
            was not found in our database.
          </p>
          <p>Please make sure you've typed in the correct url.</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <!-- youtube -->
    <v-row justify="center">
      <v-dialog v-model="youtubeDialog" max-width="500">
        <v-card>
          <v-card-title class="headline mb-2" v-if="data && data.packageCode">
            <span>{{ data.packageCode.toUpperCase() }} Package Video</span>
            <v-btn
              icon
              color="primary darken-3"
              class="ml-auto"
              @click.stop="youtubeDialog = false; videoUrl = ''"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <iframe
              style="width:100%;"
              height="315"
              :src="videoUrl"
              frameborder="0"
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              depressed
              @click="youtubeDialog = false; videoUrl = ''"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- youtube -->
  </div>
</template>

<script>
export default {
  name: "Terms",
  data: () => ({
    data: "",
    terms: "",
    dialog: false,
    youtubeDialog: false,
    videoUrl: "",
  }),
  beforeMount() {
    this.$firebase
      .firestore()
      .collection("packages")
      .doc(this.$route.params.packagecode)
      .onSnapshot((doc) => {
        if (doc.exists) {
          let data = doc.data();
          data.id = doc.id;
          this.data = data;
        } else {
          console.info("package not found");
          this.dialog = true;
        }
      });
  },
  methods: {
    onYoutube() {
      let vid = this.data.packageVideos && this.data.packageVideos.length > 0 ? this.data.packageVideos[0] : null;
      this.videoUrl = (vid && vid.downloadUrl) || (vid && vid.link) || this.data.youtubeVideoUrl;
      this.youtubeDialog = true;
      console.info(this.videoUrl);
    },
    stripHtml(html) {
      if (html.includes("&amp;")) {
        html = html.replace("&amp;", "&");
        let strippedHtml = html.replace(/<[^>]*>?/gm, "");
        return strippedHtml;
      } else {
        let strippedHtml = html.replace(/<[^>]*>?/gm, "");
        return strippedHtml;
      }
    },
  },
  watch: {
    data() {
      if (this.data.termsAndConditions) {
        this.$firebase
          .firestore()
          .collection("termsAndConditions")
          .doc(this.data.termsAndConditions)
          .onSnapshot((doc) => {
            if (doc.exists) {
              let data = doc.data();
              data.id = doc.id;
              this.terms = data;
            }
          });
      }
    },
  },
};
</script>

<style>
.blurbTitle,
.blurbTitle i {
  font-weight: bold !important;
  font-size: 110% !important;
}

.mdi {
  color: #1976d2;
}

.italic {
  font-style: italic;
}
</style>
